import {useLocation} from '@/contexts/LocationContext';
import {useNavigationContext} from '@/contexts/NavigationContext';

import SEOHead from '@/components/heads/SEOHead';
import {OnboardingBanner} from '@/components/OnboardingBanner/OnboardingBanner';

import type {OnboardingHeaderProps} from './OnboardingHeader/OnboardingHeader';

import PageSpinner from '../PageSpinner';
import OnboardingHeader from './OnboardingHeader/OnboardingHeader';
import s from './OnboardingLayout.module.scss';

type Props = {
  pageTitle?: string;
  children: React.ReactNode;
} & OnboardingHeaderProps;

export default function OnboardingLayout({
  pageTitle = 'Ka. Web App',
  children,
  ...onboardingHeaderProps
}: Props) {
  const {countryImageCode} = useLocation();
  const {loading} = useNavigationContext();

  return (
    <>
      <SEOHead pageTitle={pageTitle} />

      <div className={s.container}>
        <div className={s.content}>
          <div className={s.wrapper}>
            <OnboardingHeader {...onboardingHeaderProps} />

            {loading ? <PageSpinner /> : children}
          </div>
        </div>

        <aside className={s.aside} aria-hidden>
          <OnboardingBanner />
        </aside>
      </div>

      <footer className={s.footer}></footer>
    </>
  );
}
